export default {
  bugReportDialog: (state) => { return state.bugReportDialog }
};


// WEBPACK FOOTER //
// ./src/store/bugReport/getters.js